<template>
 
    <figure class="m-0 d-flex">
      <DynamicLinker
    v-if="mediaQueries&&!mediaQueries.mobileSize && mobileItem && mobileItem.picture"
    :item="mobileItem"
  >
    <img
    loading="lazy"
      :src="mobileItem?.picture"
      class="w-100 border-r-20"
      :alt="item?.position_description"
    />
  </DynamicLinker>


  <DynamicLinker v-else-if="item && item.picture" :item="item">
    <img
    loading="lazy"

      :src="item?.picture"
      class="w-100 border-r-20"
      :alt="item?.position_description"
    />
  </DynamicLinker>
  <Skeleton v-else></Skeleton>
    </figure>

</template>

<script>
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker";
export default {
  name: "ResponsiveBanner",
  components: { DynamicLinker },
  inject: ["mediaQueries"],
  props: {
    item: Object,
    mobileItem: Object,
  },

};
</script>

<style scoped>
.Skeleton{
  height: 300px;
}
@media screen and (max-width:600px) {
  .Skeleton{
    height: 150px;
  }
}
</style>
